"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
var UrlIdMapper_1 = require("../../utils/UrlIdMapper");
// eslint-disable-next-line import/prefer-default-export
var MediaAsset = /** @class */ (function () {
    function MediaAsset() {
    }
    MediaAsset.createInstance = function (plainObject) {
        return class_transformer_1.plainToClass(MediaAsset, plainObject);
    };
    MediaAsset.createInstances = function (plainObjectArray) {
        return class_transformer_1.plainToClass(MediaAsset, plainObjectArray);
    };
    Object.defineProperty(MediaAsset.prototype, "id", {
        get: function () {
            return UrlIdMapper_1.urlToId(this.url);
        },
        enumerable: true,
        configurable: true
    });
    return MediaAsset;
}());
exports.MediaAsset = MediaAsset;
//# sourceMappingURL=MediaAsset.js.map